import React from "react";
import './UserGuide.css'

export const UserGuide = ({ setUserGuidePopup }) => {

    const handleSubmit = () => {
        alert('Submit clicked'); // or your submit logic
    };

    return (
        <>
            <div
                className="modal fade show userGuide"
                style={{ display: "block", top: '45 %' }}
                tabIndex="-1"
                role="dialog"
            >
                <div
                    className="common-div"
                    onClick={() => setUserGuidePopup(false)}
                ></div>
                <div className="modal-dialog modal-xl pdfheight" style={{ top: '37%' }}>
                    <div className="modal-content subpdfheight" style={{ display: 'flex', flexDirection: 'column' }}>
                        <div className="landing-box-head">
                            <h5>User Guide</h5>
                            <button
                                type="button"
                                className="bttn-close"
                                onClick={() => setUserGuidePopup(false)}
                            >
                                Close
                            </button>
                        </div>
                        <div
                            className="modal-body common-scroller"
                            style={{ flex: 1, overflow: 'hidden', maxHeight: "100%", width: "100%" }}
                        >
                            <iframe
                                src={`${window.location.origin}/UserGuide/userGuide.pdf#toolbar=0&navpanes=0&scrollbar=0`}
                                title="User Guide PDF"
                                width="100%"
                                height="100%"
                                style={{ border: 'none', backgroundColor: 'white' }}
                            ></iframe>
                        </div>
                        {/* <div className="modal-footer"> */}
                        {/* <button
                                type="button"
                                className="bttn-close"
                                onClick={() => setUserGuidePopup(false)}
                            >
                                Close
                            </button> */}
                        {/* <button type="button" className="bttn" onClick={handleSubmit}>
                Submit
              </button> */}
                        {/* </div> */}
                    </div>
                </div>
            </div>
        </>
    );
};
